export function getCurrencySign(currency) {
    const signs = {
        USD: "$",
        EUR: "€",
        RUB: "₽",
    };
    return signs[currency];
}
//# sourceMappingURL=currency.js.map